import Vue from 'vue';
import App from './App.vue';
import axios from 'axios';

import echarts from 'echarts'
import url from './tool';

Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.prototype.$echart = echarts;
Vue.prototype.$url = url

new Vue({
  render: h => h(App),
}).$mount('#app')